<style lang="scss" scoped>
.offical-header {
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  width: 100%;
  color: $color-brand-accent;
  border-bottom: 1px solid #dddddd;
  position: relative;
  margin-bottom: 20px;
  &::after {
    content: '';
    position: absolute;
    left: 0px;
    bottom: -1px;
    width: 90px;
    height: 2px;
    background: $color-brand-accent;
  }
}
.box-shadow {
  // box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
  // border-radius: 5px;
  // padding: 15px 30px;
  // margin-top: 20px;
  &__title {
    font-size: 18px;
    color: #333333;
  }
}
.offical-intro {
  display: flex;
  align-items: center;
  justify-content: center;
  &__img {
    width: 70px;
    height: 70px;
  }
  &__text {
    flex: 1;
    .title {
      color: #333333;
      margin-bottom: 10px;
    }
  }
}
.setting-option {
  &__item {
    display: flex;

    justify-content: center;
    margin-bottom: 20px;
    .option-num {
      background: $color-brand-accent;
      width: 30px;
      height: 30px;
      display: block;
      border-radius: 50%;
      font-size: 18px;
      text-align: center;
      line-height: 30px;
      color: #ffffff;
      margin-top: -4px;
    }
    .improt-content {
      background: rgba($color: $color-brand-accent, $alpha: 0.07);
      border-radius: 5px;
      padding: 8px 10px;
      font-size: 14px;
      color: #666666;
      margin: 8px 0;
    }
    .option-content {
      flex: 1;
      padding: 0 15px;
    }
    .option-btn {
      width: 100px;
      margin-top: 34px;
    }
  }
}
.use-option {
  display: flex;
  .setting-option__item {
    flex: 1;
    img {
      display: block;
      margin: 20px 0 0 10%;
    }
  }
}
</style>

<template>
  <div>
    <h4 class="offical-header">
      公众号引流
    </h4>
    <SpCardContent>
      <div class="box-shadow offical-intro">
        <div class="offical-intro__img">
          <img
            :src="require('@/assets/img/setting0.jpg')"
            style="width: 90%"
          >
        </div>
        <div class="offical-intro__text">
          <h4 class="title">
            微信公众号引流
          </h4>
          <p class="content">
            企业只需复制引流链接，将其配置到微信公众号菜单，客户在公众号中点击菜单打开链接即可添加附近门店导购企业微信，可为企业吸引更精准的私域客户，客户沉淀至企业，让企业引流更高效。
          </p>
        </div>
      </div>
    </SpCardContent>

    <SpCardContent title="如何配置">
      <div class="box-shadow">
        <div class="setting-option">
          <div class="setting-option__item">
            <span class="option-num">1</span>
            <div class="option-content">
              <p>复制下方引流链接</p>
              <div class="improt-content">
                {{ link }}
              </div>
            </div>
            <div class="option-btn">
              <!-- v-clipboard:copy="link" v-clipboard:success="onCopy" -->
              <el-button
                type="primary"
                size="small"
                @click="copyLink"
              >
                复制链接
              </el-button>
            </div>
          </div>
          <div class="setting-option__item">
            <span class="option-num">2</span>
            <div class="option-content">
              <p>进入微信公众号后台配置引流链接</p>
              <div class="improt-content">
                进入微信公众平台管理后台，在「功能」菜单分区，点击「自定义菜单」按钮，在右侧配置引流链接，配置完成后点击保存即可。
              </div>
              <div>
                <img
                  :src="require('@/assets/img/setting1.png')"
                  style="width: 860px"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </SpCardContent>

    <SpCardContent title="消费者如何使用">
      <div class="box-shadow">
        <div class="setting-option use-option">
          <div class="setting-option__item">
            <span class="option-num">1</span>
            <div class="option-content">
              <p>消费者打开公众号，点击菜单，打开引流链接</p>
              <img
                :src="require('@/assets/img/setting2.png')"
                style="width: 40%"
              >
            </div>
          </div>
          <div class="setting-option__item">
            <span class="option-num">2</span>
            <div class="option-content">
              <p>长按识别页面上的二维码，添加导购企业微信。</p>
              <img
                :src="require('@/assets/img/setting3.png')"
                style="width: 40%"
              >
            </div>
          </div>
        </div>
      </div>
    </SpCardContent>
  </div>
</template>
<script>
import { getH5Url } from '@/api/drainage'

export default {
  components: {},
  data () {
    return {
      link: ''
    }
  },
  mounted () {
    this.getH5Url()
  },

  methods: {
    getH5Url () {
      getH5Url().then((res) => {
        if (res) {
          this.link = res.url
        }
      })
    },
    copyLink () {
      this.$copyText(this.link).then(
        (res) => {
          return this.$message.success('复制成功')
        },
        (err) => {
          return this.$message.error('复制失败')
        }
      )
    }
  }
}
</script>
